
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.111 16H5v1.998h10.111V16zm-1.92-7.611a1.225 1.225 0 011.591 0 .922.922 0 010 1.413L10.056 14 5.33 9.802a.922.922 0 010-1.413 1.19 1.19 0 01.793-.293c.29 0 .578.097.796.293l2.011 1.787v-8.18h2.249v8.18l2.011-1.787z","fill":"#7D7D7D","fill-rule":"evenodd"}})])
          )
        }
      }
    